import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import cx from "../landing.module.scss";
import { NavLink } from "react-router-dom";

function ReadyToStart() {
    return (
        <section className={`${cx.readySec}`}>
            <Container>
                <Row>
                    <Col md={12}>
                        <div className={`${cx.content_main}`}>
                            <h2>Ready to <span>Start</span> <br />
                                the <span>Journey</span> with us?</h2>
                                <div className={`${cx.btnBox}`}>
                                    <NavLink to={"/login"} className={`btn`}>Get Started</NavLink>
                                </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default ReadyToStart
